import patchApi from '@/api/patchApi';
import insertApi from '@/api/insertApi';
import colorsApi from '@/api/colorsApi';
import svgApi from '@/api/svgApi';

export default {
  namespaced: true,

  state: {
    patch: {
      categories: {
        isPending: false,
        activeCategoryId: null,
        activeSubCategoryId: null,
        ids: [],
        data: {}
      },
      patches: {
        isPending: false,
        activePatchId: null,
        data: {}
      },
      sizes: {
        ids: [],
        data: {}
      },
      fonts: {
        activeFont: null,
        'Text Patch': [
          {
            title: 'Font 1',
            font: 'Brisen',
            xPos: 0,
            yPosFor100px: 95
          },
          {
            title: 'Font 2',
            font: 'Freshman',
            xPos: 0,
            yPosFor100px: 95
          },
          {
            title: 'Font 3',
            font: 'cloistrk',
            xPos: 10,
            yPosFor100px: 80
          },
          {
            title: 'Font 1 Tail',
            font: 'BrisenTail',
            xPos: 0,
            yPosFor100px: 95
          },

        ],
        'Text Embroidery': [
          {
            title: 'Font 1',
            font: 'Brisen',
            xPos: 0,
            yPosFor100px: 80
          },
          {
            title: 'Font 2',
            font: 'Freshman',
            xPos: 0,
            yPosFor100px: 85
          },
          {
            title: 'Font 3',
            font: 'cloistrk',
            xPos: 10,
            yPosFor100px: 65
          }
        ]
      }
    },
    insert: {
      categories: {
        isPending: false,
        activeCategoryId: null,
        ids: [],
        data: {}
      },
      inserts: {
        isPending: false,
        data: {}
      }
    },
    colors: {
      isPending: false,
      categories: {},
    },
    schoolColors: null
  },

  getters: {
    getSizesOfPatches: (state) => ({
      ids: state.patch.sizes.ids,
      data: state.patch.sizes.data
    }),

    getCategoriesOfPatches: (state) => ({
      ids: state.patch.categories.ids,
      data: state.patch.categories.data
    }),

    getPatchesCategoryById: (state) => (id) => state.patch.categories.data[id],

    getInsertCategories: (state) => ({
      ids: state.insert.categories.ids,
      data: state.insert.categories.data
    }),

    isCategoriesPending: (state) => state.patch.categories.isPending,

    isInsertCategoriesPending: (state) => state.insert.categories.isPending,

    isInsertsPending: (state) => state.insert.inserts.isPending,

    isPatchesPending: (state) => state.patch.patches.isPending,

    isColorsPending: (state) => state.colors.isPending,

    getActiveCategoryId: (state) => state.patch.categories.activeCategoryId,

    getActiveInsertCategoryId: (state) => state.insert.categories.activeCategoryId,

    getActiveSubCategoryId: (state) => state.patch.categories.activeSubCategoryId,

    getActivePatch: (state) => state.patch.patches.data[state.patch.patches.activePatchId],

    getPatches: (state) => state.patch.patches.data,

    getPatchById: (state) => (patchId) => state.patch.patches.data[patchId],

    getInserts: (state) => state.insert.inserts.data,

    getInsertsById: (state) => (insertId) => state.insert.inserts.data[insertId],

    getColorsCategories: (state) => state.colors.categories,

    getFontsByCategory: (state) => (categoryName) => state.patch.fonts[categoryName],

    getActiveFont: (state) => state.patch.fonts.activeFont,

    getSchoolColors: (state) => state.schoolColors
  },

  mutations: {
    loadPatchCategories__PENDING (state, isPending) {
      state.patch.categories.isPending = isPending;
    },

    loadInsertCategories__PENDING (state, isPending) {
      state.insert.categories.isPending = isPending;
    },

    loadPatches__PENDING (state, isPending) {
      state.patch.patches.isPending = isPending;
    },

    loadInserts__PENDING (state, isPending) {
      state.insert.inserts.isPending = isPending;
    },

    loadPatchSizes (state, response) {
      const data = {};
      const ids = response.items.map((size) => {
        data[size.id] = {
          ...size,
          isAdditionalDataLoaded: false
        };
        return size.id;
      });
      const sizesData = {
        ...state.patch.sizes.data,
        ...data
      };
      state.patch.sizes = {
        ...state.patch.sizes,
        ids,
        data: sizesData
      };
    },

    loadPatchCategories (state, response) {
      const data = {};
      const ids = response.map((category) => {
        if (category.name === 'Text Patch' || category.name === 'Text Embroidery') {
          data[category.id] = {
            ...category,
            isAdditionalDataLoaded: false,
            isTextPatchesCategory: true
          };
        } else {
          data[category.id] = {
            ...category,
            isAdditionalDataLoaded: false
          };
        }
        return category.id;
      });

      const categoriesData = {
        ...state.patch.categories.data,
        ...data
      };

      state.patch.categories = {
        ...state.patch.categories,
        ids,
        data: categoriesData
      };
    },

    loadInsertCategories (state, response) {
      const data = {};
      const ids = response.map((category) => {
        data[category.id] = {
          ...category
        };
        return category.id;
      });

      state.insert.categories = {
        ...state.insert.categories,
        ids,
        data
      };
    },

    loadCategory (state, response) {
      const subCategoriesData = {};
      const subCategoriesIds = response.subCategories.map((category) => {
        subCategoriesData[category.id] = {
          ...category,
          isAdditionalDataLoaded: true,
          patchIds: [],
          isPatchesLoaded: false
        };
        return category.id;
      });

      Object.assign(
        state.patch.categories.data[response.id],
        response,
        {
          isAdditionalDataLoaded: true,
          subCategories: subCategoriesIds
        }
      );

      Object.assign(state.patch.categories.data, subCategoriesData);
    },

    setActiveCategory (state, categoryId) {
      state.patch.categories.activeCategoryId = categoryId;
    },

    setActiveSubCategory (state, subCategoryId) {
      state.patch.categories.activeSubCategoryId = subCategoryId;
    },

    setActivePatch (state, patchId) {
      state.patch.patches.activePatchId = patchId;
    },

    setSchoolColors (state, colorsObject) {
      state.schoolColors = colorsObject;
    },

    loadPatchesByCategory (state, { response, categoryId }) {
      const currentCategory = state.patch.categories.data[categoryId];
      if (!currentCategory.isSubCategoryEnabled) {
        currentCategory.patchIds = [];
      }

      const patchData = {};

      response.forEach((patch) => {
        const patchId = patch.id;
        patchData[patchId] = patch;

        const patchCategoryId = patch.subCategoryId || patch.categoryId;
        const category = state.patch.categories.data[patchCategoryId];

        if (category && !category.patchIds) {
          Object.assign(category, { patchIds: [] });
        }

        if (category) {
          category.patchIds.push(patchId);
        }
      });

      if (state.patch.categories.data[categoryId].subCategories) {
        state.patch.categories.data[categoryId].subCategories.forEach((subCategoryId) => {
          state.patch.categories.data[subCategoryId].isPatchesLoaded = true;
        });
      }

      Object.assign(state.patch.patches.data, patchData);
    },

    setActiveInsertCategory (state, categoryId) {
      state.insert.categories.activeCategoryId = categoryId;
    },

    loadInsertsByCategory (state, response) {
      const insertData = {};
      const insertIds = [];

      response.forEach((patch) => {
        insertData[patch.id] = {
          ...patch,
          isPending: false,
          svgText: null
        };
        insertIds.push(patch.id);
      });

      Object.assign(state.insert.inserts.data, insertData);

      const { activeCategoryId } = state.insert.categories;
      Object.assign(state.insert.categories.data[activeCategoryId], { insertIds });
    },

    loadInsert__PENDING (state, { insertId, isPending }) {
      state.insert.inserts.data[insertId].isPending = isPending;
    },

    loadInsert (state, { insertId, svgText }) {
      state.insert.inserts.data[insertId].svgText = svgText;
    },

    loadColors__PENDING (state, isPending) {
      state.colors.isPending = isPending;
    },

    loadColors (state, colors) {
      state.colors.categories = colors;
    },

    setActiveFont (state, fontData) {
      state.patch.fonts.activeFont = fontData;
    }
  },

  actions: {
    loadPatchSizes ({ commit }) {
      return patchApi.getSizes().then((response) => {
        commit('loadPatchSizes', response.data);
      });
    },

    loadPatchCategories ({ commit }) {
      commit('loadPatchCategories__PENDING', true);

      return patchApi.getCategories().then((response) => {
        commit('loadPatchCategories', response.data);
        commit('loadPatchCategories__PENDING', false);
      });
    },

    loadCategory ({ commit }, data) {
      commit('loadPatchCategories__PENDING', true);
      return patchApi.getCategory({
        categoryId: data.categoryId,
        orderId: data.orderId, 
        schoolId: data.schoolId
      })
        .then((response) => {
          commit('loadCategory', response.data);
          commit('loadPatchCategories__PENDING', false);
        });
    },

    setActiveInsertCategory ({ commit }, categoryId) {
      commit('setActiveInsertCategory', categoryId);
    },

    setActiveCategory ({ commit }, categoryId) {
      commit('setActiveCategory', categoryId);
    },

    setActiveSubCategory ({ commit }, subCategoryId) {
      commit('setActiveSubCategory', subCategoryId);
    },

    setActivePatch ({ commit }, patchId) {
      commit('setActivePatch', patchId);
    },

    setSchoolColors ({ commit }, newColorsObject) {
      commit('setSchoolColors', newColorsObject);
    },

    loadPatchesByCategory ({ commit }, { categoryId, orderId, schoolId }) {
      commit('loadPatches__PENDING', true);

      return patchApi.getPatchesByCategory(categoryId, orderId, schoolId).then((response) => {
        commit('loadPatchesByCategory', { response: response.data, categoryId, schoolId });
        commit('loadPatches__PENDING', false);
      });
    },

    loadInsertCategories ({ commit }) {
      commit('loadInsertCategories__PENDING', true);

      return insertApi.getCategories().then((response) => {
        commit('loadInsertCategories', response.data);
        commit('loadInsertCategories__PENDING', false);
      });
    },

    loadInsertsByCategory ({ commit }, categoryId) {
      commit('loadInserts__PENDING', true);

      return insertApi.getInsertsByCategory(categoryId).then((response) => {
        commit('loadInsertsByCategory', response.data);
        commit('loadInserts__PENDING', false);
      });
    },

    loadInsert ({ commit, state }, insertId) {
      const insert = state.insert.inserts.data[insertId];

      commit('loadInsert__PENDING', { insertId, isPending: true });

      return svgApi.loadSvg(insert.fileUrl)
        .then((response) => {
          commit('loadInsert', { insertId, svgText: response });
          commit('loadInsert__PENDING', { insertId, isPending: false });
        });
    },

    updateSvgInsert ({ commit }, { insertId, svgText }) {
      commit('loadInsert', { insertId, svgText });
    },

    getColors ({ commit }) {
      commit('loadColors__PENDING', true);
      return colorsApi.getColors().then((response) => {
        commit('loadColors', response.data);
        commit('loadColors__PENDING', false);
        return response.data;
      });
    },

    getSchoolColors ({ commit }) {
      commit('loadColors__PENDING', true);
      return colorsApi.getColors().then((response) => {
        console.log('colors response: ', response);
        commit('loadColors', response.data);
        commit('loadColors__PENDING', false);
        return response.data;
      });
    },

    getSpecialColors ({ commit }, schoolId) {
      commit('loadColors__PENDING', true);
      return colorsApi.getSpecialColors(schoolId).then((response) => {
        return response.data;
      });
    },

    setActiveFont ({ commit }, fontData) {
      commit('setActiveFont', fontData);
    }
  },
};
